var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenLinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5C4.22386 5 4 4.77614 4 4.5C4 4.22386 4.22386 4 4.5 4H11.1667C11.4428 4 11.6667 4.22386 11.6667 4.5V11.1667C11.6667 11.4428 11.4428 11.6667 11.1667 11.6667C10.8905 11.6667 10.6667 11.4428 10.6667 11.1667V5.70711L4.85355 11.5202C4.65829 11.7155 4.34171 11.7155 4.14645 11.5202C3.95118 11.325 3.95118 11.0084 4.14645 10.8131L9.95956 5H4.5Z",
    fill: "#3A836C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLinkIcon);
export default __webpack_public_path__ + "static/media/green-link-icon.fe5a0fac6e1c9aa469098c2d254c37cc.svg";
export { ForwardRef as ReactComponent };